export const comparisonValues = [
  { label: 'Equal', value: '0' },
  { label: 'Not Equal', value: '1' },
  { label: 'Contain', value: '2' },
  { label: 'Greater', value: '3' },
  { label: 'Greater Or Equal', value: '4' },
  { label: 'Less', value: '5' },
  { label: 'Less Or Equal', value: '6' },
  { label: 'Between', value: '7' },
];

export const dateAndNumberComparisonValues = [
  { label: 'Greater', value: '3' },
  { label: 'Greater Or Equal', value: '4' },
  { label: 'Less', value: '5' },
  { label: 'Less Or Equal', value: '6' },
  { label: 'Between', value: '7' },
];

export const numberComparisonValues = [
  { label: 'Equal', value: '0' },
  { label: 'Greater', value: '3' },
  { label: 'Greater Or Equal', value: '4' },
  { label: 'Less', value: '5' },
  { label: 'Less Or Equal', value: '6' },
  { label: 'Between', value: '7' },
];
export const stringComparisonValues = [
  { label: 'Equal', value: '0' },
  { label: 'Not Equal', value: '1' },
  { label: 'Contain', value: '2' },
];

export const otherComparisonValues = [
  { label: 'Equal', value: '0' },
  { label: 'Not Equal', value: '1' },
];
